import { FileType } from "./interfaces";
import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { formatPrice } from "./helper/price.helper";
import { API_BASE_URL } from "config/apiConfig";

export interface LabelValue {
  value: string | number;
  label: string;
}

export function getLabelFromValue<T extends LabelValue>(
  data: Record<string, T>,
  value: string | number | undefined | null,
): string | undefined {
  return Object.values(data).find((item) => item.value == value)?.label;
}

export const getBase64 = (file: FileType): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export function parseErrorMessage(error: unknown): string {
  if (error && typeof error === "object" && "data" in error) {
    const e = error as { data?: { message?: string } };
    return e.data?.message ?? "Đã xảy ra lỗi từ server";
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Đã xảy ra lỗi từ server";
}

export const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem("access_token");
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export function normalizeParams<T extends Record<string, any>>(
  params: T,
): Record<string, any> {
  const result: Record<string, any> = {};
  Object.keys(params).forEach((key) => {
    const value = params[key];
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      result[key] = value.join(",");
    } else if (typeof value === "object") {
      result[key] = normalizeParams(value);
    } else {
      result[key] = value;
    }
  });
  return result;
}

export const productPrice = (item: any) => {
  return item?.is_free ? "無料で提供する" : formatPrice(item?.price);
};

export const formatProductQuantity = (item: {
  quantity_value?: number | null;
}) => {
  if (item?.quantity_value == null) {
    return "";
  }

  return `${item.quantity_value} Kg`;
};
